import React from 'react'
import styles from './warning.module.css'
import Text from '../text/Text'
import Warning from '../../assets/icons/warning-amarillo.svg'

function WarningUI() {
    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                <img src={Warning} />
            </div>
            <p className="warning">
                <Text
                    color="#fff"
                    fontSize={13}
                    fontWeight={400}
                    label="Antes de ser publicados, asegúra que la información de tu producto cumpla con nuestra políticas de uso."
                />
            </p>
        </div>
    )
}

export default WarningUI
